import { Field, ErrorMessage } from "formik";
import React from "react";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  isRequired?: boolean;
  className?: string;
  as?: "input" | "select" | "textarea";
  rows?: number;
  cols?: number;
}

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  name,
  isRequired = true,
  className,
  as = "input",
  rows,
  cols,
  ...props
}) => {
  return (
    <div className="flex flex-col gap-2.5">
      <label htmlFor={name} className="text-[20px] text-textBlack3">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <Field
        id={name}
        name={name}
        as={as}
        rows={as === "textarea" ? rows : undefined}
        cols={as === "textarea" ? cols : undefined}
        {...props}
        className={`bg-[#A4A4A41A] border rounded-md px-5 py-4 focus:outline-none focus:ring-2 focus:ring-primary/40 ${
          className ?? ""
        }`}
      />

      <ErrorMessage
        name={name}
        component="span"
        className="text-sm absolute pt-[88px] text-gray-500"
      />
    </div>
  );
};

export default CustomInput;
